import React, { useState, useEffect } from "react";
import "./Activate.css";
import { verifyExternalUser } from "../../webapi/webapi";
import { useNavigate, useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { Translation } from "react-i18next";

const Activate = () => {
  const [token, setToken] = useState("");
  const [message, setMessage] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tokenParam = urlParams.get("token");
    setToken(tokenParam || "");
  }, [location]);

  const handleChange = () => {
    verifyExternalUser(token, password, password2).then(responseMessage => {
      if (responseMessage === "SUCCESS") {
        navigate("/signin");
      } else {
        setMessage(responseMessage);
      }
    });
  };

  const validatePasswords = (passwordtext, confirmation) => {
    setErrors([]);
    setPasswordValid(false);

    if (passwordtext.length == 0) return;
    if (confirmation.length == 0) return;

    let errors = [];

    if (passwordtext !== confirmation) {
      errors.push("passwordNoMatch");
    }

    if (
      passwordtext.length < 19 ||
      !/[A-Z]/.test(passwordtext) ||
      !/[a-z]/.test(passwordtext) ||
      !/[0-9]/.test(passwordtext)
    ) {
      errors.push("passwordReqNotMet");
    }

    setPasswordValid(errors.length == 0);
    setErrors(errors);
    // Validation logic can go here
  };

  const handlePaswoordChange = passwordtext => {
    setPassword(passwordtext);
    validatePasswords(passwordtext, password2);
  };

  const handlePaswoord2Change = passwordtext => {
    setPassword2(passwordtext);
    validatePasswords(password, passwordtext);
  };

  return (
    <Translation>
      {t => (
        <div className="container ForgotPassword">
          <div className="row justify-content-center">
            <div className="col-6">
              <h4 className="ForgotPasswordTitle">
                {t("passwordPickPassword")}
              </h4>
              <div className="ForgotPasswordSubTitle">({t("passwordReq")})</div>
              <TextField
                className="ForgotPasswordTextField"
                InputLabelProps={{ shrink: true }}
                label="wachtwoord"
                variant="outlined"
                fullWidth
                value={password}
                onChange={e => handlePaswoordChange(e.target.value)}
                type="password"
              />
              <TextField
                className="ForgotPasswordTextField"
                InputLabelProps={{ shrink: true }}
                label="herhaal wachtwoord"
                variant="outlined"
                fullWidth
                value={password2}
                onChange={e => handlePaswoord2Change(e.target.value)}
                type="password"
              />
              {errors.map(e => (
                <p style={{ color: "red" }}>{t(e)}</p>
              ))}
              <div className="ForgotPasswordActionsContainer">
                <div className="ForgotPasswordActions">
                  <Button
                    variant="contained"
                    className="ForgotPasswordAction"
                    onClick={handleChange}
                    color="primary"
                    disabled={!passwordValid}
                  >
                    Activeer
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-6 ForgotPasswordMessage">{message}</div>
          </div>
        </div>
      )}
    </Translation>
  );
};

export default Activate;
